export class Login {
    user: number;
    password: string;

    constructor(user: number, password: string) {
        this.user = user;
        this.password = password;
    }
}

export class Activity {
    idActivity: number;
    sourceSearch: string;
    amount: number;
    discount: number;
    description: string;
    code: string;
    type: string;
    email: string;
    idUsr: number;
}

export class SearchActivity {
    type: string;
    description: string;
    idSearch: number;
    amount: number;
    discount: number;
    taxes: number;
    others: any;
}

export class User {
    idUsr: number;
    name: string;
    lastname: string;
    phone: string;
    email: string;
    idUsrService: number;

    constructor(idUsr: number, name: string, lastname: string, phone: string, email: string, idUsrService: number) {
        this.idUsr = idUsr;
        this.name = name;
        this.lastname = lastname;
        this.phone = phone;
        this.email = email;
        this.idUsrService = idUsrService;
    }
}

export class CreateUser {
    name: string
    lastname: string
    phone: string
    email: string
}